import { render, staticRenderFns } from "./TableItems.vue?vue&type=template&id=7215602a"
import script from "./TableItems.vue?vue&type=script&lang=js"
export * from "./TableItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports